import type { PropsWithChildren, ReactNode } from 'react';
import {
	FormRadio as FormRadioDS,
	type FormRadioProps as FormRadioPropsDS,
} from '@gov-design-system-ce/react-form';
import { MessageWrapper } from './MessageWrapper';

interface FormRadioProps extends Omit<
	FormRadioPropsDS,
	'messageWrapper' | 'classNames' | 'radioOptionWrapper'
> {
	optionWrapperTop?: (props: PropsWithChildren) => ReactNode;
}

export const FormRadio = ({ optionWrapperTop, ...props }: FormRadioProps) => (
	<FormRadioDS
		{...props}
		label={{ size: 'm', ...props.label }}
		field={{ size: 'm', ...props.field }}
		messages={props.messages ?? { messages: [] }}
		messageWrapper={MessageWrapper}
		group={{ ...props.group }}
		radioOptionWrapper={(wrapperProps) => (
			<>
				{optionWrapperTop && optionWrapperTop(wrapperProps)}
				<div
					className={
						props.group?.orientation === 'horizontal' ? undefined : 'w-full'
					}
					{...wrapperProps}
				/>
			</>
		)}
	/>
);
